<template>
  <div
    ref="container"
    style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto;"
    :style="{ width: width, height: height }"
  >
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components'
import { LineChart } from 'echarts/charts'
import { UniversalTransition } from 'echarts/features'
import { SVGRenderer } from 'echarts/renderers'
import resizeMixin from './resizeMixin'
import moment from 'moment'
echarts.use([
  GridComponent,
  TooltipComponent,
  LegendComponent,
  LineChart,
  SVGRenderer,
  UniversalTransition
])

const lastestHalfMonth = []
const defaultSerieValue = []
for (var i = 0; i < 15; i++) {
  lastestHalfMonth.unshift(moment().add(-1 * i, 'd').format('MM/DD'))
  defaultSerieValue.push(0)
}

export default {
  name: 'OrderLineChart',
  props: {
    width: {
      type: String,
      default () {
        return '100%'
      }
    },
    height: {
      type: String,
      default () {
        return '240px'
      }
    },
    viewModel: {
      type: Array,
      default () {
        return []
      }
    },
    propMap: {
      type: Object,
      default () {
        return {
          xAxis: 'date'
        }
      }
    },
    tooltipFormater: {
      type: [String, Function],
      required: false,
      default () {
        return undefined
      }
    },
    tooltipClass: {
      type: String,
      default () {
        return undefined
      }
    }
  },
  data () {
    return {
      option: {
        legend: {
          data: ['Loading...']
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: lastestHalfMonth,
            label: {
              show: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          },
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Loading...',
            type: 'line',
            smooth: false,
            data: defaultSerieValue,
            xAxisIndex: 0,
            yAxisIndex: 0,
            areaStyle: {}
          },
          {
            name: 'Loading...',
            type: 'bar',
            smooth: false,
            stack: 'Count',
            xAxisIndex: 0,
            yAxisIndex: 1,
            data: defaultSerieValue,
            areaStyle: {}
          }
        ]
      }
    }
  },
  mixins: [resizeMixin],
  mounted () {
    if (this.tooltipFormater) {
      this.option.tooltip.formatter = this.tooltipFormater
    }
    if (this.tooltipClass) {
      this.option.tooltip.className = this.tooltipClass
    }
    this.$nextTick(() => {
      const chartDom = this.$refs.container
      if (chartDom) {
        this.chart = echarts.init(chartDom)
        this.updateData()
      }
    })
  },
  updated () {
    this.updateData()
  },
  watch: {
    viewModel () {
      this.updateData()
    }
  },
  methods: {
    updateData () {
      const legend = []
      const series = []
      for (const prop in this.propMap) {
        this.option.xAxis[0].data = this.viewModel.map(t => t[this.propMap.xAxis])
        if (prop !== 'xAxis') {
          const serieAmountData = this.viewModel.map(t => t[prop] || 0)
          const serieCountData = this.viewModel.map(t => t[prop + 'CountAll'] || 0)
          legend.push(this.propMap[prop])
          series.push({
            name: this.propMap[prop],
            type: 'line',
            smooth: false,
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: serieAmountData
          })
          series.push({
            name: this.propMap[prop],
            type: 'bar',
            stack: 'count',
            xAxisIndex: 0,
            yAxisIndex: 1,
            barWidth: '30%',
            data: serieCountData,
            areaStyle: {}
          })
        }
      }
      this.option.series = series
      this.option.legend.data = legend
      this.chart.setOption(this.option)
    }
  }
}
</script>
